import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { ToastrService } from 'ngx-toastr';
import { AdminLocalStorageService } from './admin-local-storage.service';

@Injectable()
export class AuthRegisterService implements CanActivate {

    constructor(private auth: AuthenticationService
        , private router: Router
        , private route: ActivatedRoute
        , private ls: AdminLocalStorageService
        , private toastr: ToastrService) {}

        canActivate(): Promise<boolean> {
        return new Promise(resolve => {

              console.log(location.href);
              var temp = location.href.split("#");
              var temp = temp[1].split("&");
              var data = {};
              temp.forEach(e => {
                var kv = e.split( "=");
                data[kv[0]] = kv[1];
              })
              this.ls.setToken(data["id_token"]);
              let redirectURL = "/"
              redirectURL += localStorage.getItem('redirectURL');
              this.router.navigateByUrl(redirectURL)
              resolve(true);
        });
    }
}
